// extracted by mini-css-extract-plugin
export default {"productCarousel":"Ii","twoColumns":"Ji","subhed":"Ki","promo":"Li","questionIcon":"Mi","thumbContainer":"Ni","carousel":"Oi","tape":"Pi","flexContainer":"Qi","nav":"Ri","body":"Si","reviews":"Ti","header":"Ui","hed":"Vi","priceContainer":"Wi","oldPrice":"Xi","newPrice":"Yi","infoTabs":"Zi","tabs":"aj","text":"bj","questionWrapper":"cj","isQuantity":"ej","title":"fj","titleRight":"gj","addToCart":"hj","servingsPerItem":"ij","quantityInput":"jj","quantityButton":"kj","takeTheQuiz":"lj"};
    if(module.hot) {
      // 1713211506311
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  